import React from "react";
import { useSearchParams } from "react-router-dom";
const getUrlParams = (query: any[]) => Array.from(query).reduce((p, [k, v]) => Object.assign({}, p, { [k]: p[k] ? (Array.isArray(p[k]) ? p[k] : [p[k]]).concat(v) : v }), {});
export function useSearchParamsToObject() {
  const [searchParams] = useSearchParams();
  return getUrlParams(searchParams as any);
}
